import React, { useState, useEffect } from "react";
import Background from "../CarList/Background";
import BookingInformation from "./BookingInformation";
import PersonalInformation from "./PersonalInformation";
import UploadDocument from "./UploadDocument";
import img from "../../assets/assets/images/home_images/home_grid3.png";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { matchIsValidTel } from "mui-tel-input";
import { useNavigate } from "react-router-dom";
import isToday from "dayjs/plugin/isToday";
import {
  bookCar,
  setBookingData,
  setBookingImageObj,
  setDocumentsData,
  setPersonalDetailsData,
  uploadDocImages,
} from "../../redux/Slice/bookingSlice";
import { scroller } from "react-scroll";
import BookingInformationPage from "./BookingInformationPage";
import UploadDocumentPage from "./UploadDocumentPage";
import Swal from "sweetalert2";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const personalDetailsData = useSelector(
    (state) => state?.booking?.personalDetailsData
  );
  const bookingInfoData = useSelector((state) => state?.booking?.bookingInfo);
  const bookingImageObj = useSelector(
    (state) => state?.booking?.bookingImageObj
  );
  const documentsData = useSelector((state) => state?.booking?.documentsData);
  const [phone, setPhone] = useState("");
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const { isFiltered, dateTimeInteraction } = useSelector(
    (state) => state?.car
  );
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const [errmsg, setErrMsg] = useState({
    fullName: "",
    email: "",
    address: "",
    phone: "",
    picklocation: "",
    returnlocation: "",
    pickupDate: "",
    returnDate: "",
    IDfront: "",
    IDback: "",
    licenceFront: "",
    licenceback: "",
  });
  const [personalDetail, setPersonalDetail] = useState({
    fullName: "",
    email: "",
    address: "",
    phone: "",
    phoneNumber: "",
    countryCode: "",
  });

  // search filter code set time

  // const [bookingInfo, setBookingInfo] = useState({
  //   // pickupLocation: "",
  //   // returnLocation: "",
  //   pickupDate: isFiltered
  //     ? getFormattedPickupDate(bookingInfoData?.pickUp)
  //     : null,
  //   returnDate: isFiltered
  //     ? bookingInfoData?.dropOff
  //       ? dayjs(bookingInfoData?.dropOff).startOf("day")
  //       : null
  //     : null,
  // });

  const [bookingInfo, setBookingInfo] = useState({
    // pickupLocation: "",
    // returnLocation: "",
    pickupDate: bookingInfoData?.pickUp ? dayjs(bookingInfoData?.pickUp) : null,
    returnDate: bookingInfoData?.dropOff
      ? dayjs(bookingInfoData?.dropOff)
      : null,
  });
  console.log("bookingInfoData", bookingInfoData);

  function getFormattedPickupDate(date) {
    if (!date) return null;
    const currentDate = dayjs();
    const today = dayjs().startOf("day");
    const pickupDate = dayjs(date);

    // Check if pickupDate is today
    if (pickupDate.isSame(today, "day")) {
      // isSameOrAfter  issue code
      // if (
      //   pickupDate.isAfter(currentDate, "second") ||
      //   (pickupDate.isSame(currentDate, "second") &&
      //     pickupDate.isSameOrAfter(currentDate, "minute"))
      // ) {
      if (
        pickupDate.isAfter(currentDate, "second") ||
        (pickupDate.isSame(currentDate, "second") &&
          pickupDate.isAfter(currentDate, "minute"))
      ) {
        return pickupDate; // Return pickupDate as it is in the future or now
      } else {
        return currentDate; // Return current date-time as pickupDate is in the past
      }
    } else {
      return pickupDate.startOf("day"); // Set only the date part
    }
  }

  const [userChangeToggle, setUserChangeToggle] = useState(
    bookingInfoData?.userToggle);
  const handleUserToggleChange = (e) => {
    setUserChangeToggle(!userChangeToggle);
  };

  const [uploadDoc, setUploadDoc] = useState({
    IDfront: "",
    licenceFront: "",
    // IDback: "",
    // licenceBack: ''
  });
  const [imageObj, setImageObj] = useState({
    IDfront: "",
    licenceFront: "",
  });

  // useEffect(() => {
  //   if (!bookingInfo.pickupDate) {
  //     setBookingInfo(prevInfo => ({
  //       ...prevInfo,
  //       pickupDate: new Date(),
  //     }));
  //   }
  // }, []);
  const [userInteraction, setUserInteraction] = useState(false);

  const handleBookingInfo = (event) => {
    const { name, value } = event.target;
    setBookingInfo((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handlephone = (newPhone, info) => {
    setPhone(newPhone);
    // setCountyCode(info?.countryCallingCode);
    // setPhoneNumber(info?.nationalNumber);

    setPersonalDetail({
      ...personalDetail,
      phoneNumber: info?.nationalNumber,
      countryCode: info?.countryCallingCode,
    });
    setErrMsg((prevInfo) => ({
      ...prevInfo,
      phone: "",
    }));
  };

  let pickDate = new Date(bookingInfoData?.pickUp);
  useEffect(() => {
    // if (withDriver && userDetail?.data?.drivingLicenseFront === "") {
    if (withDriver) {
      setUploadDoc((prevFormData) => ({
        ...prevFormData,
        licenceFront: "",
      }));
    }
  }, [withDriver]);
  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
    if (personalDetailsData && Object.keys(personalDetailsData)) {
      setPersonalDetail({
        fullName: personalDetailsData?.name || "",
        email: personalDetailsData?.emailId || "",
        address: personalDetailsData?.address || "",
        phone: personalDetailsData?.phone || "",
        phoneNumber:personalDetailsData?.phoneNumber || "",
        countryCode: personalDetailsData?.countryCode,
      });
      
      setPhone(`${personalDetailsData?.phone}`);
    }
    if (documentsData?.idFront || documentsData?.licence !== "") {
          setUploadDoc({
            ...uploadDoc,
            IDfront: documentsData?.idFront,
            licenceFront: documentsData?.licence,
          });
        }
      // setPersonalDetail({
      //   fullName: userDetail?.data.name
      //     ? userDetail?.data.name
      //     : personalDetailsData?.name,
      //   email: userDetail?.data.emailId
      //     ? userDetail?.data.emailId
      //     : personalDetailsData?.emailId,
      //   // address: userDetail?.data.address
      //   //   ? userDetail?.data.address
      //   //   : personalDetailsData?.address,
      //   address: personalDetailsData?.address
      //     ? personalDetailsData?.address
      //     : userDetail?.data.address?
      //     userDetail?.data.address
      //     :"",
      //   phone: userDetail?.data?.phoneNumber
      //     ? userDetail?.data?.phoneNumber
      //     : personalDetailsData?.phone,
      // });
      // setPhone(
      //   `${
      //     userDetail?.data?.phoneNumber
      //       ? userDetail?.data?.phoneNumber.trim()
      //       : personalDetailsData?.phone
      //   } `
      // );

    // 14-12-2024 code commented

    // if (userDetail?.success === true) {
    //   setPersonalDetail({
    //     fullName: personalDetailsData?.name
    //       ? personalDetailsData?.name
    //       : userDetail?.data.name,
    //     email: personalDetailsData?.emailId
    //       ? personalDetailsData?.emailId
    //       : userDetail?.data.emailId,
    //     address: personalDetailsData?.address
    //       ? personalDetailsData?.address
    //       : userDetail?.data.address
    //       ? userDetail?.data.address
    //       : "",
    //     phone: personalDetailsData?.phone
    //       ? personalDetailsData?.phone
    //       : userDetail?.data?.phoneNumber
    //       ? "+" + userDetail?.data?.country_code + userDetail?.data?.phoneNumber
    //       : "",
    //     phoneNumber: personalDetailsData?.phoneNumber
    //       ? personalDetailsData?.phoneNumber
    //       : userDetail?.data?.phoneNumber || "",
    //     countryCode: personalDetailsData?.country_code
    //       ? personalDetailsData?.country_code
    //       : userDetail?.data?.country_code || "",
    //   });
    //   setPhone(
    //     `${
    //       personalDetailsData?.phone
    //         ? personalDetailsData?.phone
    //         : userDetail?.data?.phoneNumber
    //         ? "+" +
    //           userDetail?.data?.country_code +
    //           userDetail?.data?.phoneNumber
    //         : ""
    //     } `
    //   );
    //   if (documentsData?.idFront !== "" && documentsData?.licence !== "") {
    //     setUploadDoc({
    //       ...uploadDoc,
    //       IDfront: documentsData?.idFront,
    //       licenceFront: documentsData?.licence,
    //     });
    //     setImageObj({
    //       ...imageObj,
    //       IDfront: documentsData?.idFront,
    //       licenceFront: documentsData?.licence,
    //     });
    //   } else {
    //     setUploadDoc({
    //       ...uploadDoc,
    //       IDfront: userDetail?.data?.identityFront,
    //       licenceFront: userDetail?.data?.drivingLicenseFront,
    //     });

    //     setImageObj({
    //       ...imageObj,
    //       IDfront: userDetail?.data?.identityFront,
    //       licenceFront: userDetail?.data?.drivingLicenseFront,
    //     });
    //   }
    //   // old code before reset time due to search
    //   // if (bookingInfoData?.pickUp && bookingInfoData?.dropOff) {
    //   //   setBookingInfo({
    //   //     pickupDate: dayjs(bookingInfoData?.pickUp),
    //   //     returnDate: dayjs(bookingInfoData?.dropOff),
    //   //   });
    //   // }
    //   if (bookingInfoData?.pickUp && bookingInfoData?.dropOff) {
    //     setBookingInfo({
    //       pickupDate: isFiltered
    //         ? getFormattedPickupDate(bookingInfoData?.pickUp)
    //         : dayjs(bookingInfoData.pickUp),
    //       returnDate: isFiltered
    //         ? dayjs(bookingInfoData.dropOff).startOf("day")
    //         : dayjs(bookingInfoData.dropOff),
    //     });
    //   }
    // }
  }, []);

  let interval;
  useEffect(() => {
    const checkAndUpdateTime = () => {
      const currentDate = dayjs();
      const pickupDate = dayjs(bookingInfo.pickupDate);

      if (pickupDate.isSame(currentDate, "day")) {
        if (
          pickupDate.isBefore(currentDate, "minute") ||
          (pickupDate.isSame(currentDate, "minute") &&
            pickupDate.isBefore(currentDate, "second"))
        ) {
          // Check if pickupDate is less than currentDate
          if (
            bookingInfo.pickupDate &&
            dayjs(bookingInfo.pickupDate).isSame(currentDate, "day")
          ) {
            if (dayjs(bookingInfo.pickupDate).isBefore(currentDate)) {
              setUserInteraction(false);
            }
          }
          // If the past time occurs, set userInteraction to false
          if (!userInteraction) {
            setBookingInfo((prevBookingInfo) => ({
              ...prevBookingInfo,
              pickupDate: currentDate,
            }));
          }
        }
      }
    };

    if (dayjs(bookingInfo.pickupDate).isSame(dayjs(), "day")) {
      interval = setInterval(checkAndUpdateTime, 1000); // Check every second
    }

    return () => clearInterval(interval);
  }, [bookingInfo, userInteraction]);
  const handlePersonalInfo = (event) => {
    const { name, value } = event.target;
    setErrMsg((prevInfo) => ({
      ...prevInfo,
      [name]: "",
    }));
    const nameRegex = /^[A-Za-z/ ]*$/;
    if (name === "fullName") {
      if (nameRegex.test(value)) {
        setPersonalDetail((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else
      setPersonalDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handledoc = async (event) => {
    const { name, type, files } = event.target;
    setErrMsg((prevInfo) => ({
      ...prevInfo,
      [name]: "",
    }));
    if (type === "file") {
      const file = files[0];
      let image;
      try {
        let formData = new FormData();
        formData.append("type", name);
        formData.append("image", file);
        image = await dispatch(uploadDocImages(formData))

      } catch (error) {
        console.log(error)
      }
      console.log("image", image?.payload?.data);
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result;
          setUploadDoc((prevFormData) => ({
            ...prevFormData,
            // [name]: base64Data,
            [name]: image?.payload?.data,
          }));
          setImageObj((prevFormData) => ({
            ...prevFormData,
            [name]: file.name,
          }));
        };
        reader.readAsDataURL(file);
      }
    } else {
      setUploadDoc((prevFormData) => ({
        ...prevFormData,
        [name]: event.target.value,
      }));
    }
  };

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  // function base64ToFile(base64String, fileName) {
  //   const dataUrlParts = base64String.match(/^data:(.*?);(.*?),(.*)$/);
  //   const mimeType = dataUrlParts[1];

  //   const splitBase64 = base64String.split(",");
  //   const data = splitBase64[1];

  //   const binaryData = atob(data);
  //   const uint8Array = new Uint8Array(binaryData.length);
  //   for (let i = 0; i < binaryData.length; i++) {
  //     uint8Array[i] = binaryData.charCodeAt(i);
  //   }

  //   const extension = base64String.split(";")[0].split("/")[1];
  //   const blob = new Blob([uint8Array], { type: mimeType });
  //   const file = new File([blob], `${fileName}.${extension} `, {
  //     type: mimeType,
  //   });

  //   return file;
  // }

  const handleBooking = () => {
    let newErrMsg = {};
    const isPhoneValid = matchIsValidTel(phone);
    const mailValid = isValidEmail(personalDetail?.email);
    if (userChangeToggle) {
      if (personalDetail?.fullName.trim() === "")
        newErrMsg = { ...newErrMsg, fullName: "Please Enter Full Name" };
      if (mailValid === false)
        newErrMsg = { ...newErrMsg, email: "Please Enter valid Mail" };
      if (personalDetail?.address.trim() === "")
        newErrMsg = { ...newErrMsg, address: "Please Enter Address" };
      if (!isPhoneValid)
        newErrMsg = { ...newErrMsg, phone: "Please Enter valid Phone" };
      if (uploadDoc?.IDfront === "")
        newErrMsg = { ...newErrMsg, IDfront: "Please Upload ID " };
      // if (uploadDoc?.IDback === "") newErrMsg = { ...newErrMsg, IDback: "Please Upload ID " };
      if (!withDriver) {
        if (uploadDoc?.licenceFront === "")
          newErrMsg = {
            ...newErrMsg,
            // licenceFront: "Please Upload Licence ",
            licenceFront: "Please Upload Identity Back image ",
          };
      }
    }

    // if (bookingInfo?.pickupLocation.trim() === '') newErrMsg = { ...newErrMsg, picklocation: "Please Select Pickup location" };
    // if (bookingInfo?.returnLocation.trim() === '') newErrMsg = { ...newErrMsg, returnlocation: "Please Select Return location" };
    if (bookingInfo?.pickupDate === null)
      newErrMsg = { ...newErrMsg, pickupDate: "Please Select Date&Time" };
    if (bookingInfo?.returnDate === null)
      newErrMsg = { ...newErrMsg, returnDate: "Please Select Date&Time" };

    const pickupDate = new Date(dayjs(bookingInfo?.pickupDate));
    const returnDate = new Date(dayjs(bookingInfo?.returnDate));
    const currentDate = new Date();
    if (pickupDate < currentDate.setSeconds(0, 0)) {
      newErrMsg = {
        ...newErrMsg,
        pickupDate: "Pickup date & time must be in the future.",
      };
    }
    if (returnDate <= pickupDate) {
      newErrMsg = {
        ...newErrMsg,
        returnDate: "Return date must be after the pickup date.",
      };
    }
    // if (uploadDoc?.licenceBack === "") newErrMsg = { ...newErrMsg, licenceback: "Please Upload Licence " };
    if (uploadDoc?.licenceBack === "")
      newErrMsg = {
        ...newErrMsg,
        licenceback: "Please Upload Identity Card Back side ",
      };
    if (Object.keys(newErrMsg).length > 0) {
      const firstErrorField = Object.keys(newErrMsg)[0];
      scroller.scrollTo(firstErrorField, {
        duration: 300,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -150, // Adjust offset here
      });
    }
    // Swal.fire({
    //   title: "User Details",
    //   html: `
    //     <div style="text-align: left;">
    //       <p><strong>Username:</strong> ${"voishu"}</p>
    //       <p><strong>Contact Number:</strong> ${"drijcf"}</p>
    //     </div>
    //   `,
    //   icon: "success",
    //   confirmButtonText: "Close",
    // });
    setErrMsg(newErrMsg);
    if (Object.keys(newErrMsg).length) {
      return;
    }

    // if(userChangeToggle)
    // {

    // }
    if (
      userChangeToggle &&
      (personalDetail?.fullName.trim() === "" ||
        mailValid === false ||
        personalDetail?.address.trim() === "" ||
        !isPhoneValid ||
        bookingInfo?.pickupDate === null ||
        bookingInfo?.returnDate === null ||
        uploadDoc?.IDfront === "")
      //  ||
      // uploadDoc?.licenceFront === ""
    ) {
      return;
    } else {
      dispatch(
        setBookingData({
          pickUp: bookingInfo.pickupDate,
          dropOff: bookingInfo.returnDate,
          userToggle: userChangeToggle,
        })
      );

      dispatch(
        setPersonalDetailsData({
          name: personalDetail?.fullName.trim(),
          emailId: personalDetail?.email,
          phone: phone,
          phoneNumber: personalDetail?.phoneNumber,
          countryCode: personalDetail?.countryCode,
          address: personalDetail?.address.trim(),
        })
      );
      if (imageObj?.IDfront) {
        dispatch(
          setBookingImageObj({
            idFront: !imageObj?.IDfront.includes("base64")
              ? imageObj.IDfront
              : bookingImageObj?.idFront,
            licence: !imageObj?.licenceFront.includes("base64")
              ? imageObj.licenceFront
              : bookingImageObj?.licence,
          })
        );
      }
      dispatch(
        setDocumentsData({
          idFront: uploadDoc?.IDfront,
          licence: uploadDoc?.licenceFront,
        })
      );
      navigate("/summary");
    }
  };

  return (
    <div className="container-xxl">
      <Background image={img} name="Booking" />
      <div className="container-fluid pb-6">
        <div
          className={`row mt-4 ${
            userChangeToggle ? "" : "justify-content-center"
          } `}
        >
          {/* new code removing user info section and cards */}

          {/* <div className="col-lg-4 col-md-6 mb-4 ps-0"> */}
          {/* <div className="col-sm-6 col-12 mb-4 ps-0">
            <BookingInformationPage
              bookingInfo={bookingInfo}
              setBookingInfo={setBookingInfo}
              onChange={handleBookingInfo}
              errmsg={errmsg}
              setUserInteraction={setUserInteraction}
              setErrMsg={setErrMsg}
            />
        </div>
        <div className="col-sm-6 col-12  mb-4 pe-0">
            <UploadDocumentPage
              uploadDoc={uploadDoc}
              errmsg={errmsg}
              onChange={handledoc}
              handleBooking={handleBooking}
              setErrMsg={setErrMsg}
            />
          </div>  */}
          {/* <div className="col-lg-4 col-md-6 mb-4 ps-0">
            <BookingInformation
              bookingInfo={bookingInfo}
              setBookingInfo={setBookingInfo}
              onChange={handleBookingInfo}
              errmsg={errmsg}
              setUserInteraction={setUserInteraction}
              setErrMsg={setErrMsg}
            />
          </div>
          <div className="col-lg-4 col-md-6 mb-4">
            <PersonalInformation
              setPersonalDetail={setPersonalDetail}
              personalDetail={personalDetail}
              phone={phone}
              onChange={handlePersonalInfo}
              handlephone={handlephone}
              errmsg={errmsg}
              setErrMsg={setErrMsg}
            />
          </div>
          <div className="col-lg-4 col-md-6 mb-4 pe-0">
            <UploadDocument
              uploadDoc={uploadDoc}
              errmsg={errmsg}
              onChange={handledoc}
              handleBooking={handleBooking}
              setErrMsg={setErrMsg}
            /> */}
          <div
            className={` mb-4 ps-0 ${
              userChangeToggle ? "col-lg-4 col-md-6" : "col-12 col-md-10"
            }`}
          >
            <BookingInformationPage
              bookingInfo={bookingInfo}
              setBookingInfo={setBookingInfo}
              onChange={handleBookingInfo}
              errmsg={errmsg}
              setUserInteraction={setUserInteraction}
              setErrMsg={setErrMsg}
              handleBooking={handleBooking}
              handleUserToggleChange={handleUserToggleChange}
              userChangeToggle={userChangeToggle}
            />
          </div>
          {userChangeToggle ? (
            <>
              <div className="col-lg-4 col-md-6 mb-4">
                <PersonalInformation
                  setPersonalDetail={setPersonalDetail}
                  personalDetail={personalDetail}
                  phone={phone}
                  onChange={handlePersonalInfo}
                  handlephone={handlephone}
                  errmsg={errmsg}
                  setErrMsg={setErrMsg}
                />
              </div>
              <div className="col-lg-4 col-md-6 mb-4 pe-0">
                <UploadDocumentPage
                  uploadDoc={uploadDoc}
                  errmsg={errmsg}
                  onChange={handledoc}
                  handleBooking={handleBooking}
                  setErrMsg={setErrMsg}
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Index;
